import { render, staticRenderFns } from "./edit-transaction-popup.vue?vue&type=template&id=bf8648b4&"
import script from "./edit-transaction-popup.vue?vue&type=script&lang=js&"
export * from "./edit-transaction-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports